import React from 'react'
import './Overview.css'
import PropTypes from 'prop-types'
import OverviewInfo from './OverviewInfo'
import Spinner from '../../utilities/spinner/Spinner'

//Redux
import { useDispatch, useSelector } from 'react-redux'

function UserOverview(props) {
  const { docFromYou, docToYou, role } = props
  const overview = useSelector((state) => state.overview)

  let overviewMarkup = !overview.loading ? (
    <>
      <div className='grid-item-completed'>
        <OverviewInfo
          status='Completed'
          numDocFromYou={overview.docFromYou['Completed']}
          numDocToYou={overview.docToYou['Completed']}
          role={role}
        />
      </div>
      <div className='grid-item-pending'>
        <OverviewInfo status='Pending' numDocFromYou={docFromYou['Pending']} numDocToYou={docToYou['Pending']} role={role} />
      </div>
      <div className='grid-item-declined'>
        <OverviewInfo
          status='Rejected'
          numDocFromYou={overview.docFromYou['Rejected']}
          numDocToYou={overview.docToYou['Rejected']}
          role={role}
        />
      </div>
      <div className='grid-item-expired'>
        <OverviewInfo
          status='Expired'
          numDocFromYou={overview.docFromYou['Expired']}
          numDocToYou={overview.docToYou['Expired']}
          role={role}
        />
      </div>
      <div className='grid-item-7daysPending'>
        <OverviewInfo
          status='Due in 7 days'
          numDocFromYou={docFromYou['Due7Days']}
          numDocToYou={docToYou['Due7Days']}
          role={role}
        />
      </div>
    </>
  ) : (
    <Spinner  />
  )

  return <div className='overview-grid-container'>{overviewMarkup}</div>
}

UserOverview.propTypes = {
  docFromYou: PropTypes.object.isRequired,
  docToYou: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
}

export default UserOverview
